import styled, { css } from 'styled-components';

export const Element = styled.button<{ active: boolean }>`
  ${({ theme, active, ...props }) => {
    return css`
      font-size: ${theme.typography.font_size.text_sm};
      font-weight: ${theme.typography.font_weight.text_bold};
      font-family: ${theme.typography.font_family.text};
      text-transform: uppercase;
      padding: ${theme.spacing.sm};
      color: ${theme.color.secondary_500};

      @media screen and (min-width: ${theme.breakpoint.xl}) {
        font-size: ${theme.typography.font_size.text_base};
        padding: ${theme.spacing.base};
      }

      ${active &&
      css`
        border-radius: ${theme.radius.xs} ${theme.radius.xs} 0 0;
        box-shadow: 0 1px 0 0 ${theme.color.primary_500} inset;
        background: ${theme.color.white};
      `}
    `;
  }};
`;
